import createModel, { prop } from './lib/create_model';

const FbMessengerUser = createModel({
  modelName: 'FbMessengerUser',
  properties: {
    id: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FbMessengerUser;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/fb_messenger_user.js